import axios from 'axios'

export default function useMandate() {
  const { user } = useLocalStorage()

  const hasRequiredMandate = ref(true)
  const hasEmailMandate = ref(true)
  const isLoadingMandate = ref(true)

  const fetchHasRequiredMandate = async (): Promise<boolean> => {
    try {
      const { data } = await axios.get(`/merchants/${user.value.merchant.id}/has-required-mandate`)
      hasRequiredMandate.value = data.data.hasRequiredMandate
    } catch {
      hasRequiredMandate.value = true
    }

    return hasRequiredMandate.value
  }

  const fetchHasEmailMandate = async (): Promise<boolean> => {
    try {
      const { data } = await axios.get(`/merchants/${user.value.merchant.id}/has-email-mandate`)
      hasEmailMandate.value = data.data.hasEmailMandate
    } catch {
      hasEmailMandate.value = true
    }

    return hasEmailMandate.value
  }

  const fetchMandateStatus = async (): Promise<void> => {
    isLoadingMandate.value = true
    try {
      await Promise.all([fetchHasRequiredMandate(), fetchHasEmailMandate()])
    } finally {
      isLoadingMandate.value = false
    }
  }

  const canLaunchEmailCampaign = computed(
    () => !isLoadingMandate.value && hasRequiredMandate.value && hasEmailMandate.value
  )

  return {
    hasRequiredMandate,
    hasEmailMandate,
    canLaunchEmailCampaign,
    isLoadingMandate,
    fetchMandateStatus
  }
}
